import React from "react";
import { Link } from "react-router-dom";
import { TreePine, Sparkles, Heart, Gift, ArrowRight } from "lucide-react";
import { getFeaturedOccasion } from "../data/seoContent";

const ICONS = { tree: TreePine, sparkles: Sparkles, heart: Heart, gift: Gift };

// Homepage strip promoting the soonest upcoming festive occasion.
export const FestiveBanner = () => {
  const occ = getFeaturedOccasion();
  if (!occ) return null;
  const Icon = ICONS[occ.icon] || Gift;

  return (
    <Link
      to={`/occasions/${occ.slug}`}
      data-testid="festive-banner"
      className="block group"
      style={{ background: `linear-gradient(90deg, ${occ.accent}, ${occ.accent}dd)` }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3.5 flex items-center justify-center gap-3 text-white text-center flex-wrap">
        <span className="inline-flex items-center gap-2 text-sm md:text-base font-medium">
          <Icon size={18} className="shrink-0" />
          <span><strong>{occ.badge}:</strong> {occ.tagline}</span>
        </span>
        <span className="inline-flex items-center gap-1.5 text-sm font-semibold bg-white/20 group-hover:bg-white/30 transition-colors rounded-full px-4 py-1.5">
          Order Now <ArrowRight size={15} className="group-hover:translate-x-0.5 transition-transform" />
        </span>
      </div>
    </Link>
  );
};

export default FestiveBanner;
